export const TRANSLATIONS = {
    de: {
        countdown: (countdown) => `Sie werden in <strong>${countdown}</strong> abgemeldet.`,
        extendSession: 'Sitzung verlängern',
        sessionExtended: (sessionLifespan) => `Ihre Sitzung wurde erfolgreich um ${sessionLifespan} Minuten verlängert`,
    },
    en: {
        countdown: (countdown) => `You will be logged out in <strong>${countdown}</strong>.`,
        extendSession: 'Extend session',
        sessionExtended: (sessionLifespan) => `Your session was successfully extended by ${sessionLifespan} minutes`,
    },
    es: {
        countdown: (countdown) => `Tu sesión se cerrará en <strong>${countdown}</strong>.`,
        extendSession: 'Continuar sesión',
        sessionExtended: (sessionLifespan) => `Tu sesión se ha extendido ${sessionLifespan} minutos`,
    },
    fr: {
        countdown: (countdown) => `Vous serez déconnecté dans <strong>${countdown}</strong>.`,
        extendSession: 'Prolonger la session',
        sessionExtended: (sessionLifespan) => `Votre session a été prolongée de ${sessionLifespan} minutes`,
    },
    nl: {
        countdown: (countdown) => `U wordt uitgelogd over <strong>${countdown}</strong>.`,
        extendSession: 'Sessie verlengen',
        sessionExtended: (sessionLifespan) => `Uw sessie is verlengd met ${sessionLifespan} minuten`,
    },
    pl: {
        countdown: (countdown) => `Czas pozostały do automatycznego wylogowania - <strong>${countdown}</strong>.`,
        extendSession: 'Przedłuż sesję',
        sessionExtended: (sessionLifespan) => `Twoja sesja została przedłużona o ${sessionLifespan} minut`,
    },
    fi: {
        countdown: (countdown) => `Sinut kirjataan ulos <strong>${countdown}</strong> kuluttua.`,
        extendSession: 'Pidennä istuntoa',
        sessionExtended: (sessionLifespan) => `Istuntoasi pidennettiin ${sessionLifespan} minuutilla`,
    },
};
//# sourceMappingURL=index.js.map